import styled from 'styled-components';

import { RegularBase } from 'modules/ui/typography';
import { Colors } from 'modules/ui/theme/colors';

export const ErrorText = styled(RegularBase)`
  color: ${Colors.Destructive};
`;
